import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ProductCard } from "@/components/products/ProductCard";
import { OtherProductRange } from "@/components/products/OtherProductRange";
import { MAIN_PRODUCTS } from "@/constants/products";

export default function Products() {
  return (
    <>
      <Seo
        title="Products"
        description="RKG NATURALS supplies a diverse range of agricultural, food and natural products for domestic, wholesale and international requirements."
        path="/products"
      />
      <div data-testid="products-page">
        <PageHero
          eyebrow="Products"
          title="Our Products"
          subtitle="RKG NATURALS supplies a diverse range of agricultural, food and natural products for domestic, wholesale and international requirements."
        />
        <section data-testid="products-grid" className="bg-white">
          <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {MAIN_PRODUCTS.map((product) => (
                <ProductCard key={product.testId} {...product} />
              ))}
            </div>
          </div>
        </section>
        <OtherProductRange />
      </div>
    </>
  );
}

